import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
// import Header from "../components/container/layout/client/Header";
import BusinessHeader from "../components/container/layout/business/Header";
import BusinessUserHeader from "../components/container/layout/business_user/Header";
// import BusinessUserSideBar from "../components/container/SideBar";
// import ClientSideBar from "../components/container/layout/client/SideBar";
// import FooterSection from "../components/UI/FooterSection";
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";

import { getTimeoutbycategory } from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';

import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}
const pharmaHeaderSlides = [
  {
    title: "Pharmacy System Precision & Seamless Integration",
    description:
      "Empower your pharmacy operations with a system designed for meticulous management and effortless patient care.",
  },
  {
    title: "Real-Time Inventory Insights",
    description:
      "Stay ahead of demand with dynamic inventory metrics and automated stock alerts tailored to pharmacy workflows.",
  },
  {
    title: "Streamlined Supplier Sync",
    description:
      "Connect seamlessly with suppliers through synchronized returns, order cycles, and transparent delivery tracking.",
  },
  {
    title: "Patient-Centered Dispensing Intelligence",
    description:
      "Deliver faster service with optimized dispensing queues and integrated prescription analysis tools.",
  },
];

class PharmacyManagment extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
            activeIndex: 0,
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }
    goPrev = () => {
    const { activeIndex } = this.state;
    const totalSlides = pharmaHeaderSlides.length;
    this.setState({
      activeIndex: activeIndex === 0 ? totalSlides - 1 : activeIndex - 1,
    });
  };

  goNext = () => {
    const { activeIndex } = this.state;
    const totalSlides = pharmaHeaderSlides.length;
    this.setState({
      activeIndex: activeIndex === totalSlides - 1 ? 0 : activeIndex + 1,
    });
  };

    render() {
        const { hospitaltimeout ,activeIndex } = this.state;
        const currentSlide = pharmaHeaderSlides[activeIndex];
        return (
            <div className="">
              <Helmet>
                    <title>Pharmacy Management Software & Inventory Solutions | KlinicQ</title>
                    <meta 
                        name="description" 
                        content="Track inventory, prescriptions, and billing using KlinicQ’s integrated pharmacy management system. Streamline your medical supply chain with our secure platform." 
                    />
                    <script type="application/ld+json">
                      {`
                      {
                        "@context": "https://schema.org",
                        "@type": "SoftwareApplication",
                        "name": "KlinicQ Pharmacy Management Software",
                        "url": "https://www.klinicq.com/pharmacymanagement",
                        "description": "Pharmacy management software for hospitals and clinics to manage medicine inventory, prescriptions, billing, and pharmacy operations through a secure cloud-based platform.",
                        "applicationCategory": "BusinessApplication",
                        "operatingSystem": "Web-based",
                        "publisher": {
                          "@type": "Organization",
                          "name": "KlinicQ",
                          "url": "https://www.klinicq.com"
                        }
                      }
                      `}
                    </script>
                </Helmet>

                <div className="">
                    
                    <div className="">
                      

<div className='product-section'>
    <Headerweb/>
 

            {/* <hr className='m-0' style={{ color: '#D9F4FF' }} /> */}
            <div>
       <section id="pharma-hero-section">
  <div className="pharma-hero-background">
    <div className="pharma-hero-gradient"></div>
    <img
      src={require("../../src/assets/images/website/patient-management-software-healthcare-hero.webp")}
      alt="Pharmacy management software and inventory system for hospitals and clinics by KlinicQ"
      className="pharma-hero-bg-image"
    />
  </div>
  <div className="pharma-container pharma-hero-content-container">
    <div className="pharma-hero-text">
      <h1>Revolutionizing Pharmacy & Inventory Management</h1>
      <p>
        Experience the future of pharmacy operations with our comprehensive, cutting-edge ePharmacy System.
        Designed for modern healthcare, we empower you to achieve seamless inventory management, enhanced
        patient care, and optimized operational efficiency.
      </p>
    </div>
    <div className="pharma-hero-cards">
      <div className="pharma-hero-card">
        <img
          src={require("../../src/assets/images/website/54_1095.webp")}
          alt="Real-time pharmacy inventory monitoring and stock management icon"
          className="pharma-hero-card-icon"
        />
        <div className="pharma-hero-card-text">
          <h3>Advanced Stock Monitoring</h3>
          <p>
            Track and manage inventory in real time to prevent shortages and excess stock accumulation.
          </p>
        </div>
      </div>

      <div className="pharma-hero-card">
        <div className="pharma-hero-card-icon-merged">
          
          <img src={require("../../src/assets/images/website/54_1120.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: 0, left: 0, width: "50.5px", height: "64px" }} />
          <img src={require("../../src/assets/images/website/54_1117.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "9.25px", left: "14.25px", width: "22px", height: "22px" }} />
          <img src={require("../../src/assets/images/website/54_1141.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "38.6px", left: "30.1px", width: "33.9px", height: "25.4px" }} />
          <img src={require("../../src/assets/images/website/54_1114.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "14.43px", left: "19.43px", width: "11.64px", height: "11.64px" }} />
          <img src={require("../../src/assets/images/website/54_1123.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "35px", left: "18.29px", width: "24.21px", height: "2.5px" }} />
          <img src={require("../../src/assets/images/website/54_1129.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "41.99px", left: "18.29px", width: "14.96px", height: "2.5px" }} />
          <img src={require("../../src/assets/images/website/54_1126.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "35px", left: "8px", width: "6.57px", height: "2.5px" }} />
          <img src={require("../../src/assets/images/website/54_1132.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "41.99px", left: "8px", width: "6.57px", height: "2.5px" }} />
          <img src={require("../../src/assets/images/website/54_1138.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "48.99px", left: "8px", width: "6.57px", height: "2.5px" }} />
          <img src={require("../../src/assets/images/website/54_1135.webp")} alt="" aria-hidden="true" style={{ position: "absolute", top: "48.99px", left: "18.29px", width: "2.5px", height: "2.5px" }} />
        </div>
        <div className="pharma-hero-card-text">
          <h3>Error-Free Prescription Handling</h3>
          <p>
            Automate prescription processing to minimize manual errors and streamline medicine dispensing.
          </p>
        </div>
      </div>

      <div className="pharma-hero-card">
        <img
          src={require("../../src/assets/images/website/54_1155.webp")}
          alt=""
          aria-hidden="true"
          className="pharma-hero-card-icon"
        />
        <div className="pharma-hero-card-text">
          <h3>Unified System Integration</h3>
          <p>
            Synchronize pharmacy operations with billing and supplier networks for a seamless workflow.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="pharma-features-section">
  <div className="pharma-background-shape"></div>
  <div className="pharma-container">
     <div className="pharma-features-header">
        <div className="pharma-features-header-text">
          <h2>{currentSlide.title}</h2>
          <p>{currentSlide.description}</p>
        </div>
        <div className="pharma-features-nav">
          <button className="pharma-arrow-btn" onClick={this.goPrev}>
            <img src={require("../../src/assets/images/website/54_1159.webp")} alt="" aria-hidden="true"/>
          </button>
          <button className="pharma-arrow-btn pharma-next" onClick={this.goNext}>
            <img src={require("../../src/assets/images/website/54_1157.webp")} alt="" aria-hidden="true"/>
          </button>
        </div>
      </div>

    <div className="pharma-features-grid">
      <div className="pharma-feature-card">
        <div className="pharma-card-content">
          <h3>Centralized Pharmacy Control</h3>
          <p>
            Manage multiple pharmacies with ease, consolidating operations into a single, powerful module.
            Transform your pharmacy into a fully managed shop, optimizing every aspect of its workflow.
          </p>
        </div>
        <div className="pharma-card-bg-shape bg-blue">
          <img
    src={require("../../src/assets/images/website/pharmacy-inventory-management-system.webp")}
    alt="Centralized pharmacy management dashboard for multi-branch pharmacies"
    className="pharma-card-image"
  />
        </div>
      </div>

      <div className="pharma-feature-card">
        <div className="pharma-card-content">
          <h3>Integrated Billing for Seamless Patient Experience</h3>
          <p>
            Effortlessly link your pharmacy to the main billing system for streamlined financial transactions.
            Automatically transfer medication charges to patient bills, eliminating manual entry and reducing errors.
          </p>
        </div>
        <div className="pharma-card-bg-shape  bg-blue">
          <img
    src={require("../../src/assets/images/website/pharmacy-prescription-billing-software.webp")}
    alt="Integrated pharmacy billing system connected with hospital management software"
    className="pharma-card-image"
  />
        </div>
      </div>

      <div className="pharma-feature-card">
        <div className="pharma-card-content">
          <h3>Intelligent Drug Distribution</h3>
          <p>
            Gain complete oversight of drug distribution, ensuring timely and accurate delivery.
            Simplify supplier returns with automated gate pass generation.
          </p>
        </div>
        <div className="pharma-card-bg-shape bg-blue"><img
    src={require("../../src/assets/images/website/klinicq-pharmacy-management-software.webp")}
    alt="Pharmacy drug distribution and supplier return management system"
    className="pharma-card-image"
  /></div>
      </div>
    </div>
  </div>
</div>
</div>
  <div className='single-click py-5'>
          <div className='container'>
            <div className='row m-0'>
              {/* <div className='col-lg-4 col-12 mb-lg-0 mb-3 slide-left visible'>
                
              </div> */}
              <div className='col-lg-12 col-12 py-lg-0 py-md-0 py-2 slide-right visible text-center'>

              <h3>Expert Care, Anytime, Anywhere </h3>
                <p>Experience healthcare on your terms. Access licensed doctors instantly for personalized advice and seamless health management, wherever you are. Say goodbye to waiting rooms and rigid appointments – your health is now in your hands.</p>
              </div>
             
                         <div className="image-container1">
    {/* <img src={require("../../src/assets/images/website/Rectangle19.png")} className="background-image1" alt="Background" /> */}
    <img src={require("../../src/assets/images/website/pharmacy-group78.webp")} className="foreground-image1" alt="Digital healthcare ecosystem connecting pharmacy, doctors, and patients" />
</div>
            </div>
          </div>
        </div>

                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
  
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(PharmacyManagment);